import {Fragment} from "react";
import BasicModal from "../../../common/BasicModal";
import UserInviteActionContainer from "./UserInviteActionContainer";

export default function UserInviteActionModal({title, open, handleClose, userInvite, actionType}) {

    return(
        <Fragment>
            <BasicModal
                title={title}
                open={open}
                style={{width: '500px'}}
                handleClose={handleClose}>

                <UserInviteActionContainer
                    handleClose={handleClose}
                    userInvite={userInvite}
                    actionType={actionType}
                />
            </BasicModal>
        </Fragment>
    )
}